
import { useState } from 'react'

import { Button, PortedModal } from '../../../shared/NarusMaterial'
import Allergies from '../../Standard/Allergies'

export default function AllergyModal ({ name, component, patientId }) {
  const [ isOpen, setOpen ] = useState(false)

  const actions = [
    <Button
      key={1}
      grey
      label='Close'
      onClick={() => setOpen(false)}
    />
  ]

  return (
    <div>
      <div>
        <button
          onClick={() => setOpen(true)}
          className='py-0.5 px-3 bg-red-100 rounded text-red-600 font-bold tracking-wide cursor-pointer'
        >
          {name}
        </button>
      </div>
      <PortedModal
        title='Allergies'
        actions={actions}
        open={isOpen}
        onCancel={() => {
          setOpen(false)
        }}
      >
        {component}
        <Allergies
          inModal
          patientId={patientId}
          forBanner
        />
      </PortedModal>
    </div>
  )
}
